module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-5500-Classes-Inactive-d2c3f06af5170926d9383c642d18bd9a.png";